import flatMap from "lodash/flatMap";
import includes from "lodash/includes";
import map from "lodash/map";
export function buildTreeNodes(workSpaces, selectedProjectIds, onlyProjects) {
    if (onlyProjects) {
        return flatMap(workSpaces, workSpace => map(workSpace.Projects, project => {
            const childNode = {
                id: `${project.Id}`,
                text: project.Name,
                selected: includes(selectedProjectIds, project.Id)
            };
            return childNode;
        }));
    }
    return map(workSpaces, workSpace => {
        const childNodes = map(workSpace.Projects, project => {
            const childNode = {
                id: `${project.Id}`,
                text: project.Name,
                selected: includes(selectedProjectIds, project.Id)
            };
            return childNode;
        });
        const parentNode = {
            id: `workSpace_${workSpace.Id}`,
            text: workSpace.Name,
            items: childNodes,
            selected: false,
            expanded: false
        };
        return parentNode;
    });
}
